import {readAsDataURL} from 'promise-file-reader';
import b64toBlob from 'b64-to-blob';

export function renameAllKeys(objs, newKeys) {
  let res = []
  for (var i in objs) {
    res.push(renameKeys(objs[i], newKeys))
  }
 return res;
}

export function renameKeys(obj, newKeys) {
 const keyValues = Object.keys(obj).map(key => {

   const newKey = newKeys[key] || key;
   return newKeys[key] ? { [newKey]: obj[key] } : null;
 });
 let arr = [];
 for (var key in keyValues) {
   if (keyValues[key]) {
     arr.push(keyValues[key])
   }
 }
 return Object.assign({}, ...arr)
}

export async function getErrors(res) {
  let errors = []

  if(!res)
    return [{field: null,message: "une erreur s'est produite veuillez réessayer ultérieurement "}]

  if ("form" in res) {
    for (var i in res.form.children) {
      if ("errors" in res.form.children[i]) {
        errors.push({field: i,message: res.form.children[i].errors[0]})
      }
    }
  } else if (res.length > 0 && "property_path" in res[0]) {
    for (var j in res) {
      errors.push({field: res[j].property_path,message: res[j].message})
    }
  }else if ("code" in res) { /* JWT Errors */
    errors.push({field: null,message: res.message})
  }else if ("error" in res){ /* Error 500 */
    if("exception" in res.error){
      if(res.error.exception.length > 0 && "message" in res.error.exception[0]){
        errors.push({field: null,message: res.error.exception[0].message})
      }
    }
  }

  /* Message par default si aucune erreurs parsé */
  if (errors.length === 0) {
    try {

      await res.json().then(e => {
        errors.push({field: null,message: e[0].message});
      })
    }catch(error){
      errors.push({field: null,message: "une erreur s'est produite veuillez réessayer ultérieurement "})
    }

  }
  return errors;

}

export function getBase64(file) {
   return readAsDataURL(file)
  .then(res => {
    return Promise.resolve(res);
  })
  .catch(err => {
    return Promise.reject(err)
  });
}

export function arrayBufferToBase64(buffer) {
  let binary = '';
  let bytes = [].slice.call(new Uint8Array(buffer));

  bytes.forEach((b) => binary += String.fromCharCode(b));

  return window.btoa(binary);
}

export function base64MimeType(encoded) {
  var result = null;

  if (typeof encoded !== 'string') {
    return result;
  }

  var mime = encoded.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/);

  if (mime && mime.length) {
    result = mime[1];
  }

  return result;
}

export function downloadBase64(b64Data) {
  var contentType = 'application/pdf';

  var blob = b64toBlob(b64Data.split(",")[1], contentType);

  var blobUrl = URL.createObjectURL(blob);
  window.location = blobUrl;
}



// WEBPACK FOOTER //
// ./src/utils/tools.js